import { useState } from "react";

import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

import { usePermission } from "@/auth/usePermission";
import { DesiderataAdminPage } from "@/pages/DesiderataAdminPage";
import { DesiderataPage } from "@/pages/DesiderataPage";
import { useAuthStore } from "@/store/authStore";

/**
 * Routing wrapper:
 *  - DOCTOR (no admin perm) → only the personal page
 *  - COORDINATOR / ORG_ADMIN / TENANT_ADMIN → admin page + (if they are a practitioner) personal tab
 */
export function DesiderataRouter() {
  const { t } = useTranslation();
  const me = useAuthStore((s) => s.me);
  const canManage = usePermission("desiderata_window:read");

  const isPractitioner = Boolean(me?.id) && !me?.is_god && true; // always show personal tab for tenant users
  const [tab, setTab] = useState(0);

  if (!canManage) {
    return <DesiderataPage />;
  }

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
      >
        <Tab label={t("desiderata.manageTitle")} />
        {isPractitioner && <Tab label={t("desiderata.title")} />}
      </Tabs>
      {tab === 0 && <DesiderataAdminPage />}
      {tab === 1 && <DesiderataPage />}
    </Box>
  );
}
